import React from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import pluralize from 'pluralize'

import { Card } from '@/components/cards/Card'
import { EChart } from '@/components/charts/EChart'
import { CHART } from '@/components/charts/chartPalette'

export const FeatureFeedbackCards = () => {
  const { aggregate } = useSelector((state) => state.featureFeedback.data)

  if (isEmpty(aggregate)) {
    return null
  }

  const modifyFeedbackNames = ([name, counts]) => {
    if (name === 'Active Coaching') {
      return ['AI Coaching', counts]
    }
    if (name === 'Summary') {
      return ['Notes', counts]
    }

    return [name, counts]
  }

  const features = Object.entries(aggregate)
    .map(modifyFeedbackNames)
    .map(([name, counts]) => {
      const total = counts.total_count
      const positivePercent = total > 0 ? Math.round((counts.positive_count / total) * 100) : 0
      const negativePercent = total > 0 ? Math.round((counts.negative_count / total) * 100) : 0

      return {
        name,
        total,
        positive: counts.positive_count,
        negative: counts.negative_count,
        positivePercent,
        negativePercent,
      }
    })

  // Calculate aggregate stats for "All Features"
  const aggregateStats = {
    name: 'All Features',
    total: features.reduce((sum, f) => sum + f.total, 0),
    positive: features.reduce((sum, f) => sum + f.positive, 0),
    negative: features.reduce((sum, f) => sum + f.negative, 0),
  }
  aggregateStats.positivePercent =
    aggregateStats.total > 0
      ? Math.round((aggregateStats.positive / aggregateStats.total) * 100)
      : 0
  aggregateStats.negativePercent =
    aggregateStats.total > 0
      ? Math.round((aggregateStats.negative / aggregateStats.total) * 100)
      : 0

  const getChartOption = (feature) => ({
    animation: false,
    grid: {
      left: 0,
      right: 0,
      top: 25,
      bottom: 25,
      containLabel: false,
    },
    xAxis: {
      type: 'category',
      data: ['Positive', 'Negative'],
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        fontSize: 12,
      },
    },
    yAxis: { type: 'value', max: 100, show: false },
    series: [
      {
        type: 'bar',
        data: [
          {
            value: feature.positivePercent,
            itemStyle: {
              color: CHART.SUCCESS_BG,
              borderColor: CHART.SUCCESS,
              borderWidth: 1,
              borderRadius: 4,
            },
          },
          {
            value: feature.negativePercent,
            itemStyle: {
              color: CHART.CRITICAL_BG,
              borderColor: CHART.CRITICAL,
              borderWidth: 1,
              borderRadius: 4,
            },
          },
        ],
        barWidth: '95%',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}%',
          fontSize: 16,
          fontWeight: 700,
          color: CHART.TEXT,
        },
        emphasis: { disabled: true },
      },
    ],
  })

  return (
    <div className="equal-grid mbl">
      {[aggregateStats, ...features].map((feature) => (
        <Card
          key={feature.name}
          compact
          title={feature.name}
          subtitle={pluralize('response', feature.total, true)}
        >
          <EChart option={getChartOption(feature)} style={{ height: '100px' }} />
        </Card>
      ))}
    </div>
  )
}
